import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AdminSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isLinkActive = useCallback(
    (href: string) => {
      return location.pathname.startsWith(href);
    },
    [location],
  );

  return (
    <aside className="aside">
      <div className="aTit">사용자 관리</div>
      <ul className="aMenuList">
        <li className={`aMenuUser ${isLinkActive('/main/admin/user-list') ? 'on' : 'hide'}`}>
          <div
            className="aMenuTit"
            onClick={() => {
              navigate('/main/admin/user-list');
            }}
          >
            사용자 목록(비번 초기화)
          </div>
        </li>

        <li className={`aMenuUser ${isLinkActive('/main/admin/login-list') ? 'on' : 'hide'}`}>
          <div
            className="aMenuTit"
            onClick={() => {
              navigate('/main/admin/login-list');
            }}
          >
            로그인 정보 조회
          </div>
        </li>

        <li className={`aMenuUser ${isLinkActive('/main/admin/service-list') ? 'on' : 'hide'}`}>
          <div
            className="aMenuTit"
            onClick={() => {
              navigate('/main/admin/service-list');
            }}
          >
            서비스 접속 정보 조회
          </div>
        </li>
      </ul>
    </aside>
  );
};

export default AdminSidebar;
